
export default {
    state: {
        filters: {
            search: "",            
        }
    },    

    mutations: {   
        TRACKERS_SET_FILTER(state, { key, value }) {
            state.filters = {
                ...state.filters,
                [key]: value
            };
        },
        
    }
};
